module.exports = __webpack_public_path__ + "img/welfareBg2.86732e49.png";